const STRUCT = {
  ID: 'id',
  BRIEF: 'brief',
  CLIENT_ID: 'client_id',
};

export default STRUCT;
